// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r-drawer__overlay {
    position: absolute;
    inset: 0;
    transform: scale3d(0, 0, 0);
  }

    .r-drawer__overlay--open {
      transform: scale3d(1, 1, 1);
    }
  .r-drawer__content {
    will-change: contents;
    position: absolute;
    display: flex;
    transition: transform 450ms cubic-bezier(0.25, 0.8, 0.25, 1);

    /* overflow: auto; */

    /* Add iOS momentum scrolling. */
    --webkit-overflow-scrolling: 'touch';

    max-width: 100%;
    max-height: 100%;
  }
  .r-drawer__content-top {
      inset: 0 0 auto;
      max-width: 100%;
      max-height: 100%;
      transform: translate3d(0, calc(-100%), 0);
    }
  .r-drawer__content-top--open {
        transform: translate3d(0, 0, 0);
      }
  .r-drawer__content-bottom {
      inset: auto 0 0;
      height: auto;
      max-width: 100%;
      max-height: 100%;
      transform: translate3d(0, calc(100%), 0);
    }
  .r-drawer__content-bottom--open {
        transform: translate3d(0, 0, 0);
      }
  .r-drawer__content-left {
      inset: 0 auto 0 0;
      max-width: 100%;
      max-height: 100%;
      transform: translate3d(calc(-100%), 0, 0);
    }
  .r-drawer__content-left--open {
        transform: translate3d(0, 0, 0);
      }
  .r-drawer__content-right {
      inset: 0 0 0 auto;
      max-width: 100%;
      max-height: 100%;
      transform: translate3d(calc(100%), 0, 0);
    }
  .r-drawer__content-right--open {
        transform: translate3d(0, 0, 0);
      }
  .r-drawer--fullscreen {
    position: fixed;
    max-width: 100vw;
    max-height: 100vh;
  }
`, "",{"version":3,"sources":["webpack://./app/components/Drawer/style.css"],"names":[],"mappings":"AACE;IACE,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;EAK7B;;IAHE;MACE,2BAA2B;IAC7B;EAGF;IACE,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,4DAA4D;;IAE5D,oBAAoB;;IAEpB,gCAAgC;IAChC,oCAAoC;;IAEpC,eAAe;IACf,gBAAgB;EA8ClB;EA5CE;MACE,eAAe;MACf,eAAe;MACf,gBAAgB;MAChB,yCAAyC;IAK3C;EAHE;QACE,+BAA+B;MACjC;EAGF;MACE,eAAe;MACf,YAAY;MACZ,eAAe;MACf,gBAAgB;MAChB,wCAAwC;IAK1C;EAHE;QACE,+BAA+B;MACjC;EAGF;MACE,iBAAiB;MACjB,eAAe;MACf,gBAAgB;MAChB,yCAAyC;IAK3C;EAHE;QACE,+BAA+B;MACjC;EAGF;MACE,iBAAiB;MACjB,eAAe;MACf,gBAAgB;MAChB,wCAAwC;IAK1C;EAHE;QACE,+BAA+B;MACjC;EAIJ;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB","sourcesContent":[".r-drawer {\n  &__overlay {\n    position: absolute;\n    inset: 0;\n    transform: scale3d(0, 0, 0);\n\n    &--open {\n      transform: scale3d(1, 1, 1);\n    }\n  }\n\n  &__content {\n    will-change: contents;\n    position: absolute;\n    display: flex;\n    transition: transform 450ms cubic-bezier(0.25, 0.8, 0.25, 1);\n\n    /* overflow: auto; */\n\n    /* Add iOS momentum scrolling. */\n    --webkit-overflow-scrolling: 'touch';\n\n    max-width: 100%;\n    max-height: 100%;\n\n    &-top {\n      inset: 0 0 auto;\n      max-width: 100%;\n      max-height: 100%;\n      transform: translate3d(0, calc(-100%), 0);\n\n      &--open {\n        transform: translate3d(0, 0, 0);\n      }\n    }\n\n    &-bottom {\n      inset: auto 0 0;\n      height: auto;\n      max-width: 100%;\n      max-height: 100%;\n      transform: translate3d(0, calc(100%), 0);\n\n      &--open {\n        transform: translate3d(0, 0, 0);\n      }\n    }\n\n    &-left {\n      inset: 0 auto 0 0;\n      max-width: 100%;\n      max-height: 100%;\n      transform: translate3d(calc(-100%), 0, 0);\n\n      &--open {\n        transform: translate3d(0, 0, 0);\n      }\n    }\n\n    &-right {\n      inset: 0 0 0 auto;\n      max-width: 100%;\n      max-height: 100%;\n      transform: translate3d(calc(100%), 0, 0);\n\n      &--open {\n        transform: translate3d(0, 0, 0);\n      }\n    }\n  }\n\n  &--fullscreen {\n    position: fixed;\n    max-width: 100vw;\n    max-height: 100vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
